import React from 'react'
import moment from 'moment'
import 'moment/locale/en-gb'
import 'moment/locale/ru'
import 'moment/locale/es'
import {DateRangePicker, SingleDatePicker, DayPickerRangeController} from 'react-dates';
import {Button, Col, Form, FormGroup, Input, Row} from "reactstrap";
import dateHelpers from "../../../helpers/DateHelper";
import paymentTypeHelpers from "../../../helpers/PaymentTypeHelper";
import Select from "react-select";
import constants from "../../../shared/constants";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../../translations/resource_translations";
import {common_strings} from "../../../translations/common_translations";
import localeHelpers from "../../../helpers/LocaleHelper";
import businessHelper from "../../../helpers/BusinessHelper";
import {MdRefresh} from "react-icons/md";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditTicketView extends React.Component {
    constructor(props) {
        super(props);
        moment.locale(businessHelper.business().locale)
        this.state = {
            ticket: props.ticket,
            ticketType: props.ticketType,
            selectedPaymentType: null,
            inputsUpdated: true,
            validation: {
                start: true,
                end: true,
                classes_left: true,
                price: true,
            }
        };

        window.EditTicketView = this

    }

    componentWillUnmount() {
        window.EditTicketView = null
    }

    handleChange = this.handleChange.bind(this);

    handleChange(event) {
        // this.setState({
        //     inputsUpdated: true,
        // });

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-start":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        start: newValue
                    }
                }));
                break;
            case "input-end":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        end: newValue
                    }
                }));
                break;
            case "input-purchase-date":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        purchase_date: newValue
                    }
                }));
                break;
            case "input-classes-left":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        classes_left: newValue
                    }
                }));
                break;
            case "input-unlimited-cb":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        classes_left: checkBoxValue ? -5 : 0
                    }
                }));
                break;
            case "input-price":

                const updatedPrice = parseFloat(newValue.replace(/,/g, '-.'));
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        price: updatedPrice
                    }
                }));

                break;
            case "input-subscription-cb":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        renewable: checkBoxValue
                    }
                }));
                break;
            case "input-note":
                this.setState(prevState => ({
                    ticket: {
                        ...prevState.ticket,
                        note: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.ticket !== this.props.ticket || nextProps.ticketType !== this.props.ticketType) {
            this.setState({
                ticket: nextProps.ticket,
                ticketType: nextProps.ticketType,
            })
        }
        if (nextState.ticket !== this.state.ticket
            || nextState.ticketType !== this.state.ticketType
            || nextState.selectedTicketType !== this.state.selectedTicketType
            || nextState.inputsUpdated !== this.state.inputsUpdated
            || nextState.validation.start !== this.state.validation.start
            || nextState.validation.end !== this.state.validation.end) {
            this.setState({
                ticket: nextState.ticket,
                ticketType: nextState.ticketType,
                selectedTicketType: nextState.selectedTicketType,
                inputsUpdated: nextState.inputsUpdated,
                validation: nextState.validation,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.ticket !== this.state.ticket) {
            this.handleValidation();
        }
    }

    updateTicket(e) {
        e.preventDefault();
        const pt = this.state.selectedPaymentType ? this.state.selectedPaymentType.value : (this.state.ticket.pt ? this.state.ticket.pt : paymentTypeHelpers.defaultPaymentMethod().value)

        if (this.validationCleared()) {
            let t = this.state.ticket;
            t.pt = pt;
            if (this.state.ticketType && this.state.ticketType.is_enrolment) {
                t.is_enrolment = true
            }

            this.props.updateTicket(t);
        }
    }

    render() {
        this.localize();
        return (
            <Form onSubmit={this.handleSubmit}>
                {((this.state.ticketType && this.state.ticketType.is_enrolment) || this.state.ticket.is_enrolment) &&
                <Row className="pl-lg-4">
                    <Col className="text-right">
                        <label style={{
                            fontWeight: 700,
                            color: "#318245",
                            marginRight: 20
                        }}>{resourceStrings.is_enrolment}</label>
                    </Col>
                </Row>
                }

                <div className="pl-lg-4">
                    <label
                        className="form-control-label"
                        htmlFor="start_date_inout"
                    >
                        <i className="fas fa-calendar-day text-primary"/> {resourceStrings.valid_from}
                    </label>

                    <Row>
                        <Col>
                            <FormGroup>
                                {this.canShowDatePickers() &&
                                <>
                                    {!this.isUnlimitedTicket() ?
                                        <DateRangePicker
                                            startDate={moment(this.state.ticket.start)} // momentPropTypes.momentObj or null,
                                            startDateId="start_date_input" // PropTypes.string.isRequired,
                                            endDate={moment(this.state.ticket.end)} // momentPropTypes.momentObj or null,
                                            endDateId="end_date_input" // PropTypes.string.isRequired,
                                            onDatesChange={({startDate, endDate}) => this.updateDates({
                                                startDate,
                                                endDate
                                            })} // PropTypes.func.isRequired,
                                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                            onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,\
                                            enableOutsideDays={true}
                                            isOutsideRange={() => false}
                                            displayFormat={() => moment.localeData('fr').longDateFormat('L')}
                                        /> :
                                        (<>
                                            <SingleDatePicker
                                                date={moment(this.state.ticket.start)} // momentPropTypes.momentObj or null
                                                onDateChange={date => this.updateStartDate({date})} // PropTypes.func.isRequired
                                                focused={this.state.focused} // PropTypes.bool
                                                onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
                                                isOutsideRange={() => false}
                                                id="start_date_input" // PropTypes.string.isRequired,
                                            />

                                            <label
                                                className="form-control-label ml-4"
                                            >
                                                <i className="fas fa-infinity text-primary"/> {resourceStrings.unlimited}
                                            </label>

                                        </>)
                                    }
                                </>
                                }

                                {this.canShowDatePickers() == false &&
                                <div className="text-warning">
                                    {resourceStrings.starts_on_use_expl}
                                </div>}
                            </FormGroup>
                        </Col>

                    </Row>

                    {!(this.state.ticketType && this.state.ticketType.is_enrolment) && !this.state.ticket.is_enrolment &&
                    <Row>
                        <Col lg="4">
                            <FormGroup>
                                <label
                                    className="form-control-label"
                                    htmlFor="input-classes-left"
                                >
                                    {resourceStrings.number_of_classes}
                                </label>
                                <Input
                                    className={this.state.validation.classes_left ? "form-control-alternative" : "is-invalid"}
                                    onChange={this.handleChange}
                                    value={this.getClassesLeft()}
                                    id="input-classes-left"
                                    type="number"
                                    pattern="[0-9]*"
                                    placeholder="0"
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <div className="custom-control custom-checkbox"
                                     style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>
                                    <input
                                        className="custom-control-input"
                                        id="input-unlimited-cb"
                                        type="checkbox"
                                        onChange={this.handleChange}
                                        checked={this.getUnlimitedState()}
                                    />
                                    <label className="custom-control-label" htmlFor="input-unlimited-cb">
                                        {resourceStrings.unlimited}
                                    </label>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    }
                    <Row>
                        <Col lg="4">
                            <FormGroup>
                                <label
                                    className="form-control-label"
                                    htmlFor="input-address"
                                >
                                    {resourceStrings.price} ({this.props.currency})
                                </label>
                                <Input
                                    className={this.state.validation.price ? "form-control-alternative" : "is-invalid"}
                                    onChange={this.handleChange}
                                    defaultValue={this.state.ticket.price || 0}
                                    id="input-price"
                                    min="0"
                                    type="number"
                                    pattern="^\d+(?:\.\d{1,2})?$"
                                    placeholder="0.00"
                                />

                                {this.state.ticket.promo_code_name &&
                                    <small style={{fontWeight: "bold", color: "brown"}}>{resourceStrings.promo_code} {": "} {this.state.ticket.promo_code_name}</small>
                                }
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <label
                                    className="form-control-label"
                                >
                                    {commonStrings.payment_method}
                                </label>
                                <Row>
                                    <Col lg="10">
                                        <Select
                                            style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}
                                            className="form-control-alternative"
                                            placeholder={commonStrings.select}
                                            value={this.getPaymentMethod()}
                                            onChange={this.handlePaymentMethodSelected}
                                            options={paymentTypeHelpers.paymentTypes()}
                                        />
                                    </Col>
                                    <Col lg="2">
                                        <span className="btn-inner--icon">
                                            {this.state.selectedPaymentType ?
                                                (<img
                                                    width={24}
                                                    height={24}
                                                    alt="pm"
                                                    src={this.getPaymentMethodIcon()}
                                                />) : (<img
                                                    width={24}
                                                    height={24}
                                                    alt="pm"
                                                    src={this.getPaymentMethodIcon()}
                                                />)}
                                         </span>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                    {!(this.state.ticketType && this.state.ticketType.is_enrolment) && !this.state.ticket.is_enrolment &&
                    <>
                        <Row>
                            <Col lg="10">
                                <div>
                                    <FormGroup>
                                        <div className="custom-control custom-checkbox"
                                             style={{position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>
                                            <input
                                                className="custom-control-input"
                                                id="input-subscription-cb"
                                                type="checkbox"
                                                onChange={this.handleChange}
                                                checked={this.getRenewableStatus()}
                                            />
                                            <label className="custom-control-label" htmlFor="input-subscription-cb">
                                                {resourceStrings.subscription}
                                            </label>
                                            <MdRefresh style={{marginBottom: 10, marginLeft: 4}} size="14px" className="rotate-image"/>
                                        </div>
                                    </FormGroup>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="10">
                                <div className="text-secondary text-muted">
                                    <small>
                                        {resourceStrings.subscription_expl}
                                    </small>

                                </div>
                            </Col>
                        </Row>
                    </>
                    }
                    <Row>
                        <Col lg="10" className="mt-4">
                            <FormGroup>
                                <label
                                    className="form-control-label"
                                    htmlFor="input-note"
                                >
                                    {commonStrings.note}
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-note"
                                    placeholder=""
                                    onChange={this.handleChange}
                                    defaultValue={this.state.ticket && this.state.ticket.note ? this.state.ticket.note : ''}
                                    rows="3"
                                    type="textarea"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="4">
                            <FormGroup>
                                <label
                                    className="form-control-label"
                                    htmlFor="input-purchase-date"
                                >
                                    <i className="fas fa-calendar-day text-primary"/> {resourceStrings.purchase_date}
                                </label>
                                <Input
                                    className="form-control-alternative"
                                    onChange={this.handleChange}
                                    defaultValue={dateHelpers.cleanup(this.state.ticket.purchase_date)}
                                    id="input-purchase-date"
                                    type="date"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    {this.isMembershipTicket() &&
                    <label
                        className="form-control-label"
                    >
                        <img
                            className="mr-2 ml-0"
                            width={18}
                            height={18}
                            alt="pm"
                            src={require("assets/img/icons/membership.svg").default}
                        /> {this.state.ticket.subscription_id}
                    </label>
                    }
                </div>

                <Row>
                    <Col lg="12">
                        <Col className="text-right">
                            <Button
                                color="warning"
                                outline="button"
                                size="lg"
                                onClick={e => this.props.closeTicketView(e)}
                            >
                                {commonStrings.cancel}
                            </Button>

                            <Button
                                color={this.validationCleared() ? "default" : "secondary"}
                                disabled={!this.validationCleared()}

                                size="lg"
                                onClick={e => this.updateTicket(e)}
                            >
                                {commonStrings.save}
                            </Button>
                        </Col>
                    </Col>
                </Row>

                {this.state.ticket && this.state.ticket.price_id &&
                    <Row>
                        {/*STRIPE DATA*/}
                        <Col lg="12">
                            <FormGroup style={{verticalAlign: 'center='}}>
                                <small style={{fontWeight: 600}} >
                                    Stripe Price: <a href={`https://dashboard.stripe.com/prices/${this.state.ticket.price_id}`} target="_blank">{this.state.ticket.price_id}</a>  <br/>
                                    Stripe Product: <a href={`https://dashboard.stripe.com/products/${this.state.ticket.product_id}`} target="_blank">{this.state.ticket.product_id}</a>  <br/>
                                </small>

                            </FormGroup>
                        </Col>
                    </Row>
                }

            </Form>
        )
    }

    isMembershipTicket() {
        return this.state.ticket && this.state.ticket.membership
    }

    canShowDatePickers() {
        if (this.state.ticket == null) {
            return this.state.ticketType && (!this.state.ticketType.starts_on_use || this.state.ticketType.starts_on_use == false)
        } else {
            return this.state.ticket.start != null
        }

    }

    getStartDate() {
        if (this.state.ticket != null) {

        } else if (this.props.ticketType != null) {
            const tt = this.props.ticketType;
            const res = dateHelpers.databaseDate(tt.start_first_day === true ? dateHelpers.firstDayOfMonth() : new Date());

            this.setState(prevState => ({
                ticket: {
                    ...prevState.ticket,
                    start: res
                }
            }));

            return res;
        }
    }

    getEndDate() {
        if (this.state.ticket != null) {

        } else if (this.props.ticketType != null) {
            const tt = this.props.ticketType;
            const dur = tt.duration;
            const units = tt.units;

            if (dur && units) {
                const dateStart = tt.start_first_day === true ? dateHelpers.firstDayOfMonth() : new Date();
                if (units === 'm') {
                    const plusMonths = dateHelpers.addMonth(dateStart, dur);
                    const minusDay = dateHelpers.addDay(plusMonths, -1);

                    const res = dateHelpers.databaseDate(minusDay);

                    this.setState(prevState => ({
                        ticket: {
                            ...prevState.ticket,
                            end: res
                        }
                    }));

                    return res;
                } else {
                    const plusDays = dateHelpers.addDay(dateStart, dur);

                    const res = dateHelpers.databaseDate(plusDays);

                    this.setState(prevState => ({
                        ticket: {
                            ...prevState.ticket,
                            end: res
                        }
                    }));

                    return res;
                }
            }
        }
    }

    getClassesLeft() {
        if (this.state.ticket != null) {
            const t = this.state.ticket;
            return t.classes_left > 0 ? t.classes_left.toString() : (t.classes_left === -5 ? "unlimited" : "")
        } else if (this.props.ticketType !== null) {
            const tt = this.props.ticketType;
            return tt.classes_left > 0 ? tt.classes_left.toString() : (tt.classes_left === -5 ? "unlimited" : "")
        }
    }

    getPrice() {
        if (this.state.ticket != null) {

        } else if (this.props.ticketType != null) {
            const tt = this.props.ticketType;
            return tt.price || 0.00
        }
    }

    getPaymentMethod() {
        if (this.state.selectedPaymentType === null) {
            if (this.state.ticket != null) {
                let pm = paymentTypeHelpers.paymentTypes().find(p => p.value === this.state.ticket.pt);

                if (pm === undefined) {
                    pm = paymentTypeHelpers.defaultPaymentMethod()
                }

                return pm
            } else {
            }
        } else {
            return this.state.selectedPaymentType
        }
    }

    handlePaymentMethodSelected = selectedOption => {
        paymentTypeHelpers.storeDefaultPaymentMethod(selectedOption ? selectedOption.value : null)

        this.setState({
                selectedPaymentType: selectedOption
            }
        )
    };

    getUnlimitedState() {
        if (this.state.ticket !== undefined) {
            return this.state.ticket.classes_left ? this.state.ticket.classes_left === -5 : false;
        } else {
            return this.state.ticketType.classes_left === -5
        }
    }

    getRenewableStatus() {
        let res;

        if (this.state.ticket && this.state.ticket.renewable !== undefined) {
            res = this.state.ticket.renewable === true
        } else {
            res = this.state.ticketType.renewable === true
        }
        return res
    }

    validateDates() {
        if (this.isUnlimitedEnd()) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: true,
                    end: true,
                }
            }));
        } else {
            const start = new Date(this.state.ticket.start);
            const end = new Date(this.state.ticket.end);

            if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
                this.setState(prevState => ({
                    validation: {
                        ...prevState.validation,
                        start: start <= end,
                        end: start <= end,
                    }
                }));
            } else {
                this.setState(prevState => ({
                    validation: {
                        ...prevState.validation,
                        start: dateHelpers.isValidDate(start),
                        end: dateHelpers.isValidDate(end),
                    }
                }));
            }
        }
    }

    handleValidation() {
        this.validateDates();
        this.validateClassesLeft();
        this.validatePrice();
    }

    validateClassesLeft() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                classes_left: this.state.ticket.classes_left === -5 || this.state.ticket.classes_left > -1,
            }
        }));
    }

    validatePrice() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                price: parseFloat(this.state.ticket.price) > -1
            }
        }));
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    getPaymentMethodIcon() {
        const ppt = paymentTypeHelpers.paymentTypes();
        if (this.state.selectedPaymentType) {
            return this.state.selectedPaymentType.icon
        } else {
            if (this.state.ticket.pt) {
                const pt = ppt.find(p => p.value === this.state.ticket.pt);
                if (pt) {
                    return pt.icon
                } else {
                    return paymentTypeHelpers.defaultPaymentMethod().icon
                }
            } else {
                return paymentTypeHelpers.defaultPaymentMethod().icon
            }
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

    isUnlimitedTicket() {
        const check1 = new Date(this.state.ticket.end) == "Invalid Date"
        const check2 = !dateHelpers.isValidDate(new Date(this.state.ticket.end))

        return !this.state.ticket.end || check1 || check2
    }

    renderEndDate() {

        return !dateHelpers.isValidDate(new Date(this.state.ticket.end)) ? (
            <p>
                {resourceStrings.unlimited_ticket}
            </p>
        ) : (
            <Input
                className={this.state.validation.end === true ? "form-control-alternative" : "is-invalid"}
                onChange={this.handleChange}
                defaultValue={this.state.ticket.end}
                id="input-end"
                type="date"
            />
        )

    }

    isUnlimitedEnd() {
        return this.state.ticket.end === constants.open.ENDLESS_TICKET || this.state.ticket.end === "-3"
            || this.state.ticket.end === resourceStrings.unlimited || !dateHelpers.isValidDate(new Date(this.state.ticket.end))
    }

    updateDates(param) {
        if (!this.isUnlimitedTicket() && param.endDate == null) {
            param.endDate = param.startDate
        }
        this.setState(prevState => ({
            ticket: {
                ...prevState.ticket,
                start: param.startDate,
                end: param.endDate
            }
        }));
    }

    updateStartDate(date) {
        if (!date || !date.date)  return

        const newDate = date.date.format('YYYY-MM-DD')
        this.setState(prevState => ({
            ticket: {
                ...prevState.ticket,
                start: newDate,
            }
        }));
    }
}

EditTicketView.propTypes = propTypes;

export default EditTicketView;